import { useNavigate } from 'react-router'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchJSON } from '../../../../../../../../utils/hooks/useFetchJson'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import locations from '../../../../../../../../utils/globals/locations'

interface ModalDeleteWorkSheetProps extends ModalEditComponentProps { }

const ModalDeleteWorkSheet: React.FC<ModalDeleteWorkSheetProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/workSheet/deleteWorkSheet',
        data: allRowData || {}
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => { handleFetchJSON(); navigate(locations.workSheets) }} translations={{
            title: t('sureDeleteWorkSheet', '¿Seguro que quieres eliminar esta hoja de trabajo?'),
            subtitle: t('onceDeactivateNotRecover', 'Una vez desactivada no podrás recuperarla'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

export default ModalDeleteWorkSheet